import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { EnvironmentService } from "../environment.service";
import { IProductSalesKitsGETModel, IProductSalesKitsPOSTModel, IProductSalesKitsPUTModel } from "../../models/product/dto/product-sales-kits/product-sales-kits.model";

@Injectable({
    providedIn: 'root'
})
export class ProductSalesKitsService {
    fullPath: string;

    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {
        this.fullPath = `${envService.settings.apiUrl}/Products`;
    }

    public get(productId: number): Observable<IProductSalesKitsGETModel> {
        return this.httpClient.get<IProductSalesKitsGETModel>(`${this.fullPath}/${productId}/salesKitDetails`)
    }

    public save(model: IProductSalesKitsPOSTModel, productId: number): Observable<IProductSalesKitsPOSTModel> {
        return this.httpClient.post<IProductSalesKitsPOSTModel>(`${this.fullPath}/${productId}/salesKitItem`, model);
    }

    public update(model: IProductSalesKitsPUTModel, form: any): Observable<IProductSalesKitsPUTModel> {
        return this.httpClient.put<IProductSalesKitsPUTModel>(`${this.fullPath}/${form.productId}/salesKitDetails/${form.salesKitProductId}`, model);
    }

    public deleteSalesKitItem(ids: number[], productId: number): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: {
                productId: productId,
                salesKitProductIds: ids
            }
        };
        return this.httpClient.delete<boolean>(`${this.fullPath}/${productId}/salesKitItem`, httpOptions);
    }

    deleteKitItemFromSelectedKit(ids: number[], productId: number): Observable<boolean> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: {
                productId: productId,
                salesKitProductIds: ids
            }
        };
        return this.httpClient.delete<boolean>(`${this.fullPath}/${productId}/salesKits`, httpOptions);
    }
}